if (!customElements.get("personalisation-box")) {
  customElements.define(
    "personalisation-box",
    class PersonalisationBox extends HTMLElement {
      constructor() {
        super();

        this.letterVariants = JSON.parse(
          this.querySelector('[type="application/json"]').textContent.replace(
            /,\s*]/,
            "]"
          )
        );

        this.minimumPrice = this.querySelector("#letters-minimum-price");
        this.livePrice = this.querySelector("#letters-live-price");
        this.options = this.querySelector("#letters-options");
        this.inputBox = this.querySelector("#letters-input");
        this.inputErrors = this.querySelector("#letters-input-errors");
        this.addToCartButton = this.querySelector("#add-letters-to-cart");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.registerEvents();

        this.MINIMUM_LETTERS_NEEDED = 1;
        this.MAXIMUM_LETTERS_ALLOWED = 15;

      }

      connectedCallback() {
        this.handleDatalayer();
      }

      registerEvents() {
        this.options
          .querySelectorAll("input")
          .forEach((input) =>
            input.addEventListener("click", this.handleUserInput.bind(this))
          );

        this.inputBox.addEventListener(
          "input",
          this.handleUserInput.bind(this)
        );

        this.addToCartButton.addEventListener(
          "click",
          this.handleAddToCart.bind(this)
        );
      }

      handleUserInput({ target }) {
        const isHeight = target.name?.toLowerCase() === "height";

        this.validateInput();
        this.updatePrice(isHeight);
      }

      updatePrice(update) {
        if (
          this.inputBox.value.length >= this.MINIMUM_LETTERS_NEEDED &&
          this.inputBox.value.length <= this.MAXIMUM_LETTERS_ALLOWED
        ) {
          const { validVariantPrices } = this.extractLetterData();
          const sumPrice = validVariantPrices.reduce(
            (total, item) => total + item.price,
            0
          );
          const sumCompareAtPrice = validVariantPrices.reduce(
            (total, item) => total + item.compare_at_price,
            0
          );

          this.minimumPrice.classList.add("hidden");
          this.livePrice.classList.remove("hidden");
          this.livePrice.querySelector("#live-price").textContent =
            Shopify.formatMoney(sumPrice) + ` ${Shopify.currency.active}`;

          if (Number(sumCompareAtPrice) > Number(sumPrice)) {
            this.livePrice.querySelector("#live-compare-at").textContent =
              Shopify.formatMoney(sumCompareAtPrice) +
              ` ${Shopify.currency.active}`;
          } else {
            this.livePrice
              .querySelector("#live-compare-at")
              .classList.add("hidden");
          }
        } else {
          this.livePrice.classList.add("hidden");
          this.minimumPrice.classList.remove("hidden");
        }
        
        if(update) {
          const { validVariantPrices } = this.extractLetterData();
          const netPrice = validVariantPrices.reduce(
            (total, item) => total + item.price,
            0
          );
          
          if(netPrice > 0) {
            const netCompareAtPrice = validVariantPrices.reduce(
              (total, item) => total + item.compare_at_price,
              0
            );
  
            const priceEl = document.querySelector("[js-product-price]");
            const comparePriceEl = document.querySelector("[js-product-compare-price]");
  
            priceEl.setAttribute("data-price", Shopify.formatMoney(netPrice).replace(/[^0-9.]/g, ""));
  
            if(comparePriceEl && Number(netCompareAtPrice) > Number(netPrice)) {
              const discountPrice = Number(netCompareAtPrice) - Number(netPrice);
              comparePriceEl.setAttribute("data-discount-price", Shopify.formatMoney(discountPrice).replace(/[^0-9.]/g, ""))
            }
          };
  
          this.handleDatalayer();
        }
      }

      handleAddToCart() {
        const { validIds } = this.extractLetterData();

        if (!validIds.length) {
          alert("Please enter valid name.");
          return;
        }

        const cartReadyItems = validIds.map((id) => {
          return {
            id,
            quantity: 1,
          };
        });

        const formData = {
          items: cartReadyItems,
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        };

        this.cart.setActiveElement(document.activeElement);

        this.addToCartButton.setAttribute("disabled", true);
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Show the real error to the shopper and let them try again.
              this.inputErrors.textContent =
                response.description || response.message || "Sorry, something went wrong. Please try again.";
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);

            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "personalisation-box",
                cartData: response,
                formElement: this,
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            // Always re-enable the button so the shopper can retry after an error.
            this.addToCartButton.removeAttribute("disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            // Only reset the input on success; keep their text and the error visible otherwise.
            if (!this.error) {
              this.inputBox.value = "";
              this.inputErrors.textContent = "";
              this.livePrice.classList.add("hidden");
              this.minimumPrice.classList.remove("hidden");
            }
          });
      }

      extractLetterData() {
        let validIds = [];
        let validVariantPrices = [];
        let variantAvailability = [];

        const lettersToAdd = this.inputBox.value.split("");
        const uppercaseLetters = lettersToAdd.map((letter) =>
          letter.toUpperCase()
        );
        const selectedVariant = this.querySelector(
          ".product-form__input input:checked"
        ).value;

        for (let i = 0; i < uppercaseLetters.length; i++) {
          const letter = uppercaseLetters[i];

          for (let j = 0; j < this.letterVariants.length; j++) {
            const variantName = this.letterVariants[j].name;
            if (
              variantName.includes(selectedVariant) &&
              variantName.includes(`Letter ${letter}`)
            ) {
              const variantId = this.letterVariants[j].id;
              const variantAvailable = {
                letterName: letter,
                variantName: selectedVariant,
                available: this.letterVariants[j].available,
              };
              const variantPrices = {
                price: this.letterVariants[j].price,
                compare_at_price: this.letterVariants[j].compare_at_price,
              };

              validIds.push(variantId);
              validVariantPrices.push(variantPrices);
              variantAvailability.push(variantAvailable);
            }
          }
        }

        return { validIds, validVariantPrices, variantAvailability };
      }

      validateInput(value) {
        const { variantAvailability } = this.extractLetterData();
        const unavailableVariant = variantAvailability.find(
          (letter) => letter.available === false
        );
        const atLeastOneUnavailable = Boolean(unavailableVariant);

        this.inputBox.value = this.inputBox.value.replace(/[^a-zA-Z]/g, "");

        if (this.inputBox.value.length < this.MINIMUM_LETTERS_NEEDED) {
          this.inputErrors.textContent = `Minimum ${this.MINIMUM_LETTERS_NEEDED} letter required.`;
          this.addToCartButton.setAttribute("disabled", true);
        } else if (this.inputBox.value.length > this.MAXIMUM_LETTERS_ALLOWED) {
          this.inputErrors.textContent = `Maximum ${this.MAXIMUM_LETTERS_ALLOWED} letters allowed.`;
          this.inputBox.value = this.inputBox.value.slice(0, this.MAXIMUM_LETTERS_ALLOWED);
        } else {
          if (atLeastOneUnavailable) {
            this.inputErrors.textContent = `Letter ${unavailableVariant.letterName}/${unavailableVariant.variantName} is currently sold out.`;
            this.addToCartButton.setAttribute("disabled", true);
            return;
          }

          this.inputErrors.textContent = "";
          this.addToCartButton.removeAttribute("disabled");
        }
      }

      handleDatalayer() {
        if(localStorage.getItem("productIndex")) {
          this.setAttribute("data-index", localStorage.getItem("productIndex"))
        };
        
        const currency = this.getAttribute("data-currency");
        const category = this.getAttribute("data-category");
        const index = +this.dataset.index || 0;
        const quantity = 1;

        const priceEl = document.querySelector("[js-product-price]");
        const comparePriceEl = document.querySelector("[js-product-compare-price]");

        if(priceEl) {
          const price = parseFloat(priceEl.getAttribute("data-price"));
          const productId = this.getAttribute("data-product-id");
          let comparePrice = 0;

          if(comparePriceEl) {
            comparePrice = parseFloat(comparePriceEl.getAttribute("data-discount-price"));
          }

          const heightField = this.querySelector('input[name="height" i]:checked');
          const colour = getOptionValue([], ["colour", "color"]);
          const material = getOptionValue([], ["material"]);
          const size = getOptionValue([], ["size"]);
          let height;
          
          if(heightField) {
            height = getOptionValue([
              {
                "name": "height",
                "value": heightField.value
              }
            ], ["height"]);
          }else {
            height = getOptionValue([], ["height"]);
          }

          dataLayer.push({
            event: "view_item_ce",
            platform: document.documentElement.clientWidth > 767 ? "d-web" : "m-web",
            ecommerce: {
              currency: currency,
              value: price,
              items: [
                {
                  item_id: this.getAttribute("data-product-id"),
                  item_name: this.getAttribute("data-product-title"),
                  discount: comparePrice,
                  index: index,
                  item_brand: this.getAttribute("data-product-vendor"),
                  item_category: category || "NA",
                  item_category2: colour,
                  item_category3: material,
                  item_variant: size,
                  item_height: height,
                  item_list_name: getListNameById(productId),
                  item_list_id: this.getAttribute("data-section-id"),
                  price: price,
                  quantity: 1
                }
              ]
            }
          });
        }
      }
    }
  );
}
